import Cookie from 'js-cookie';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { isExternalLink } from 'utils/isExternalLink';
import { hashBytes } from 'utils/murmurHash3';
import { createUniqueId } from 'utils/createUniqueId';

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: { fields: any };
};

// -- Wed Jan 13 2038 19:20:55 GMT
const COOKIE_EXPIRE_DATE = new Date(2147023255552);

const SplitTest = ({ entry }: Props): JSX.Element => {
  const router = useRouter();
  let guid = '';

  // eslint-disable-next-line
  // @ts-ignore
  useEffect(() => {
    const { cookieName } = entry.fields;

    if (!Cookie.get(cookieName)) {
      const uuid = createUniqueId();
      Cookie.set(cookieName, uuid, {
        expires: COOKIE_EXPIRE_DATE,
      });

      guid = Cookie.get(cookieName) || '';
    } else {
      guid = Cookie.get(cookieName) || '';
    }

    guid = Cookie.get(entry.fields.cookieName) || '';
    const seed = 0;
    const hash = hashBytes(guid, guid?.length, seed);
    const probability = (Math.abs(hash) % 100) + 1;

    const ranges = entry.fields.redirects?.map(
      (field: { url: string; probability: string }, i: number) => {
        let start;
        if (i === 0) {
          start = 0;
        } else if (i > 1) {
          start = entry.fields.redirects
            ?.slice(0, i)
            .reduce(
              (total: number, redirect: { url: string; probability: string }) =>
                total + redirect.probability,
              0,
            );
        } else {
          start = entry.fields.redirects?.[i - 1].probability;
        }

        const end = start + field.probability;

        return `${start}-${end}`;
      },
    );

    const index = ranges.map((range: string, i: number) => {
      const rangeStart = parseInt(range.split('-')[0]);
      const rangeEnd = parseInt(range.split('-')[1]);
      const a = Array.from(
        { length: rangeEnd - rangeStart + 1 },
        (_, i) => i + rangeStart,
      );

      if (a.includes(probability)) {
        return i;
      }
    });

    const targetIndex = index.filter(
      (e?: number) => typeof e !== 'undefined',
    )[0];

    const getParams = router.asPath.split('?')[1] || null;
    const redirectUrl = `${entry.fields.redirects?.[targetIndex].url}${
      getParams ? `?${getParams}` : ''
    }`;

    if (redirectUrl) {
      if (isExternalLink(redirectUrl)) {
        window.location.href = redirectUrl;
        return;
      }

      return router.push(redirectUrl).then(() => window.scrollTo(0, 0));
    }
  }, []);

  return <></>;
};

export default SplitTest;
